import SockJS from 'sockjs-client'
import Stomp, { Frame } from 'stompjs'
import { getUserId } from './util'
let socket: WebSocket
export let stompClient: Stomp.Client
const socketconnect = (
  successcallback: (message: Frame) => void,
  errorcallback?: (error: string | Frame) => void,
) => {
  try {
    const info = getUserId()
    socket = new SockJS('/socket')
    stompClient = Stomp.over(socket)
    // 随机key
    const key = Math.random().toString(36).substr(2)
    const headers = {
      login: key,
      passcode: key + 666,
    }
    stompClient.connect(
      headers,
      () =>
        stompClient.subscribe(`/user/${info}/notice`, successcallback, headers),
      errorcallback,
    )
  } catch (error) {}
}

// 销毁ws 取消订阅
export const socketdisconnect = () => {
  try {
    const info = getUserId()
    stompClient.disconnect(() => {
      stompClient.unsubscribe(`/user/${info}/notice`)
    })
  } catch (error) {}
}

export default socketconnect
import SockJS from 'sockjs-client'
import Stomp, { Frame } from 'stompjs'
import { getUserId } from './util'
let socket: WebSocket
export let stompClient: Stomp.Client
const socketconnect = (
  successcallback: (message: Frame) => void,
  errorcallback?: (error: string | Frame) => void,
) => {
  try {
    const info = getUserId()
    socket = new SockJS('/socket')
    stompClient = Stomp.over(socket)
    // 随机key
    const key = Math.random().toString(36).substr(2)
    const headers = {
      login: key,
      passcode: key + 666,
    }
    stompClient.connect(
      headers,
      () =>
        stompClient.subscribe(`/user/${info}/notice`, successcallback, headers),
      errorcallback,
    )
  } catch (error) {}
}

// 销毁ws 取消订阅
export const socketdisconnect = () => {
  try {
    const info = getUserId()
    stompClient.disconnect(() => {
      stompClient.unsubscribe(`/user/${info}/notice`)
    })
  } catch (error) {}
}

export default socketconnect
